import React from 'react';

import PropTypes from 'prop-types';

import ErrorBoundary from 'components/application/ErrorBoundary';

import CurrentActor, {
  currentActorContextPropsStructure,
} from 'components/contexts/CurrentActor';
import Toaster from 'components/contexts/Toaster';

export default function AppWrapper({ actors, children }) {
  return (
    <ErrorBoundary>
      <CurrentActor {...actors}>
        <Toaster>{children}</Toaster>
      </CurrentActor>
    </ErrorBoundary>
  );
}

AppWrapper.propTypes = {
  actors: PropTypes.exact(currentActorContextPropsStructure),
  children: PropTypes.node,
};
